import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BrevoContact, SsrServerResponse } from '../../shared/models';
import { BrevoInitialData } from '../../shared/constants';

@Injectable({
  providedIn: 'root',
})
export class BrevoService {
  private readonly contactsUrl = '/api/contacts';
  private readonly automateUrl = '/api/automate';

  contact: BrevoContact = BrevoInitialData;

  constructor(private readonly http: HttpClient) {}

  findContact(identifier: string) {
    const url = `${this.contactsUrl}/find/${identifier}`;
    return this.http.get<SsrServerResponse>(url, { headers: { 'not-loading': 'true' } });
  }

  createContact(data: BrevoContact) {
    return this.http.post<SsrServerResponse>(this.contactsUrl, data, {
      headers: { 'not-loading': 'true' },
    });
  }

  updateContact(data: BrevoContact): Observable<void> {
    const emailEncoded = encodeURIComponent(data.email);
    const url = `${this.contactsUrl}/${emailEncoded}`;
    return this.http.put<void>(url, data, {
      headers: { 'not-loading': 'true' },
    });
  }

  identifyUser(email: string, attributes?: unknown) {
    const url: string = `${this.automateUrl}/customers/identify`;
    const data = { email, attributes };
    return this.http.post<SsrServerResponse>(url, data, { headers: { 'not-loading': 'true' } });
  }

  trackEvent(event: string, data?: any, email?: string) {
    const resolvedEmail = email ?? this.contact.email;
    if (!resolvedEmail) {
      console.warn('trackEvent: No email provided');
      return of<SsrServerResponse>({ success: false });
    }

    const url = `${this.automateUrl}/trackEvent`;
    const body: any = { event, email: resolvedEmail, ...(data && { eventData: { data } }) };

    return this.http.post<SsrServerResponse>(url, body, { headers: { 'not-loading': 'true' } });
  }

  sendTransactionalEmail(payload: unknown) {
    const url: string = '/api/emails/transactional/send';
    return this.http.post<SsrServerResponse>(url, payload);
  }
}
